import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { submitContactForm } from "../api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", org: "", message: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    Object.entries(form).forEach(([k, v]) => {
      if (!v.trim()) newErrors[k] = "This field is required";
    });
    if (Object.keys(newErrors).length) { setErrors(newErrors); return; }

    setLoading(true);
    try {
      await submitContactForm(form);
      toast.success("Your request has been submitted!");
      setForm({ name: "", email: "", org: "", message: "" });
    } catch (_) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <style>{`
        .ct-grid {
          display:grid;
          grid-template-columns:1fr 1.4fr;
          gap:60px;
          align-items:start;
        }
        .ct-input {
          width:70%;
          background:#111e33;
          border:1px solid #1e2e45;
          border-radius:8px;
          padding:10px 14px;
          font-size:13px;
          color:#c8d6e5;
          outline:none;
          box-sizing:border-box;
          font-family:'Segoe UI',sans-serif;
        }
        .ct-input.error { border:1px solid #e05252; }
        .ct-btn {
          width:70%;
          background:#998046;
          color:#080d20;
          border:none;
          border-radius:8px;
          padding:12px;
          font-size:14px;
          font-weight:600;
          cursor:pointer;
        }
        @media(max-width:768px){
          .ct-grid { grid-template-columns:1fr; gap:36px; }
          .ct-input { width:100%; }
          .ct-btn   { width:100%; }
        }
      `}</style>

      <Toaster position="top-center" toastOptions={{ style: { background: "#111e33", color: "#e8f0fa", fontSize: 13 } }} />

      <p style={s.label}>CONTACT</p>
      <h1 style={s.heading}>Let's talk about <strong>verified presence</strong>.</h1>
      <p style={s.sub}>
        Book a demo or send us a message. We'll show you how Verisaya can replace
        your paper registers with audit-ready records.
      </p>

      <div className="ct-grid">
        {/* Left */}
        <div>
          <p style={s.leftText}>
            Whether you're running training sessions today or planning events
            tomorrow, we'd love to hear from you.
          </p>
          {[
            { key: "EMAIL",    val: "[your@verisaya.com]" },
            { key: "PHONE",    val: "[+230 0000 0000]" },
            { key: "LOCATION", val: "[Mauritius]" },
          ].map((item) => (
            <div key={item.key} style={{ marginBottom: 20 }}>
              <p style={s.infoLabel}>{item.key}</p>
              <div style={s.block}>
                <div style={s.bar} />
                <p style={s.infoVal}>{item.val}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Right — Form */}
        <div>
          {[
            { label: "Name",         name: "name",  placeholder: "Your name",       type: "text" },
            { label: "Work email",   name: "email", placeholder: "you@company.com", type: "email" },
            { label: "Organisation", name: "org",   placeholder: "Your company",    type: "text" },
          ].map((f) => (
            <div key={f.name} style={{ marginBottom: 16 }}>
              <p style={s.fieldLabel}>{f.label}</p>
              <input
                type={f.type}
                name={f.name}
                placeholder={f.placeholder}
                value={form[f.name]}
                onChange={handle}
                className={`ct-input${errors[f.name] ? " error" : ""}`}
              />
              {errors[f.name] && <p style={s.err}>{errors[f.name]}</p>}
            </div>
          ))}

          <div style={{ marginBottom: 20 }}>
            <p style={s.fieldLabel}>Message</p>
            <textarea
              name="message"
              placeholder="Tell us what you'd like to see..."
              value={form.message}
              onChange={handle}
              rows={5}
              className={`ct-input${errors.message ? " error" : ""}`}
              style={{ resize: "vertical" }}
            />
            {errors.message && <p style={s.err}>{errors.message}</p>}
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="ct-btn"
            style={loading ? { opacity: 0.7, cursor: "not-allowed" } : {}}
          >
            {loading ? "Sending..." : "Request a Demo"}
          </button>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:       { background:"#080d20", minHeight:"100vh", padding:"clamp(40px,6vw,60px) clamp(20px,10%,120px)", color:"#c8d6e5", fontFamily:"'Segoe UI', sans-serif" },
  label:      { fontSize:11, letterSpacing:2, color:"#998046", textTransform:"uppercase", margin:"0 0 14px" },
  heading:    { fontSize:"clamp(26px,4vw,38px)", fontWeight:300, color:"#e8f0fa", margin:"0 0 16px", lineHeight:1.2 },
  sub:        { fontSize:14, color:"#868fa2", margin:"0 0 40px", maxWidth:500, lineHeight:1.6 },
  leftText:   { fontSize:14, color:"#868fa2", lineHeight:1.7, margin:"0 0 32px" },
  infoLabel:  { fontSize:12, letterSpacing:2, color:"#998046", textTransform:"uppercase", margin:"0 0 6px" },
  block:      { display:"flex", gap:12, alignItems:"flex-start" },
  bar:        { width:3, minHeight:20, background:"#1e3a5f", borderRadius:2, flexShrink:0, marginTop:2 },
  infoVal:    { fontSize:13, color:"#7a9bbf", fontStyle:"italic", margin:0, lineHeight:1.6 },
  fieldLabel: { fontSize:13, color:"#8A93A6", margin:"0 0 6px" },
  err:        { margin:"4px 0 0", fontSize:12, color:"#e05252" },
};
